﻿// ****************************** css ******************************
 
require('jquery-ui/themes/base/base.css');
require('jquery-ui/themes/base/theme.css'); 

require("bootstrap-sass/assets/stylesheets/_bootstrap.scss");
require("bootstrap-sass");

// ****************************** js ******************************

const $ = require("jquery");
window.$ = $;
window.jQuery = $;

window.signalR = require("@aspnet/signalr/dist/browser/signalr.js");
window.Raphael = require("raphael");



//jquery-ui的包, 分为几十个小包, 要各自引用. 
//require("jquery-ui");

// webpack 兼容低版本IE很复杂, 因此这里不再考虑低版本的IE, 只兼容 IE 11, 因此也不考虑低版本的 jquery-ui 了.
// https://github.com/zuojj/fedlab/issues/5

require("jquery-ui/ui/position");
require("jquery-ui/ui/effect");
require("jquery-ui/ui/effects/effect-highlight");


require("jquery-ui/ui/widgets/dialog");
require("jquery-ui/ui/widgets/datepicker");
require("jquery-ui/ui/widgets/selectable");

// 
// require("blueimp-file-upload/js/jquery.fileupload.js");
// require("blueimp-file-upload/js/jquery.iframe-transport");
// 
// require("jstree");

//window.fecha = require("fecha");   

